import { Component, Vue, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import FontAwesomeIcon from '@/components/icons/font-awesome-icon/font-awesome-icon';
import { Drag, Drop } from 'vue-drag-drop';
import { competencyModelAPI } from '@/providers/apis/competency-model/competency-model';
import { sessionService } from '@/providers/services/auth/session';
@Component({
  name: 'upload-model',
  components: {
    'material-icon': GoogleMaterialIcon,
    'font-awesome': FontAwesomeIcon,
    Drag,
    Drop,
  },
})
export default class UploadModel extends Vue {
  public fileName: any;
  public errorMessage: string = '';
  @Prop()
  private cardName!: string;

  @Prop({default: []})
  private classificationList: any;

  private files: any = [];
  private session: any = null;
  private userId: any = null;
  private tenantId: any = null;
  private progression: any = true;
  private subjectCode: any = null;
  private subjectsList: any = [];
  // -----------------------------------------------------------------------
  // Actions

  private onGoBack(data: any) {
    this.$emit('onGoBack', false);
  }

  // ------------------------------------------------------------------------
  // Hooks

  private created() {
    window.scrollTo(0, 0);
    this.session = sessionService.getSession();
    this.userId = this.session.user_id;
    this.tenantId = this.session.tenant.tenant_id;
    this.populateSubjects();
  }

  private populateSubjects() {
    const select = {code: 'None', id: 'None', title: 'None'};
    this.subjectsList.push(select);
    for (const item of this.classificationList) {
      // Iterate through each subject in the current data object
      for (const subject of item.subjects) {
        this.subjectsList.push(subject);
      }
    }
  }

  // --------------------------------------------------------------------------
  // Methods

  private isValidXlsx(file: File): boolean {
    const isXlsxExt = file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx');
    return isXlsxExt;
  }

  private handleDrop(e: any) {
    if (e.dataTransfer.files.length) {
      const file = e.dataTransfer.files[0];
      if (file && this.isValidXlsx(file)) {
        this.files = e.dataTransfer.files;
        this.fileName = file.name;
      } else {
        alert('Only .xlsx files are allowed.');
        (this.$refs.file as HTMLInputElement).value = '';
      }
    }
    // this.upload();
  }

  private onChange(e: any) {
    if (e.target.files.length) {
    const file =  e.target.files[0];
    if (file && this.isValidXlsx(file)) {
      this.files = e.target.files;
      this.fileName = file.name;
    } else {
      alert('Only .xlsx files are allowed.');
      (this.$refs.file as HTMLInputElement).value = '';
    }
  }
    // this.upload();
  }

  private handleFileUpload(e: any) {
    // this.files = e.target.files;
    this.upload();
  }


  private upload() {
    const formData = new FormData();
    for (let i = 0; i < this.files.length; i++) {
      const file = this.files[i];
      formData.append('files[' + i + ']', file);
    }
    if (this.subjectCode === 'None') {
      this.subjectCode = null;
    }
    competencyModelAPI.upoadFile(formData, this.userId, this.tenantId, this.progression, this.subjectCode)
    .then((res) => {
      if (res.status === 200) {
        this.onGoBack(res.data);
      }
      if (res.status === 500) {
        this.errorMessage = res.errorMsg;
      }
    });
  }
}
